// TODO(#693 follow-up): replace TSA_TEXT and BAA_TEXT with legal-reviewed
// final copy before launch. Constants are intentionally marked `(Placeholder)`
// so the copy is obvious in manual QA and search.

export const TSA_TEXT = `Technology Services Agreement (Placeholder)

This Technology Services Agreement ("Agreement") is a placeholder executed by Determa ("Platform") and the provider identified in the onboarding signature block ("Provider"). The final legal text will replace this content prior to production launch.

1. Services. Platform provides HIPAA-compliant software for clinical documentation, scheduling, and patient-facing telehealth intake. Provider accesses the Services as an independent practitioner and retains all clinical judgment and responsibility.

2. Account & Access. Provider is responsible for safeguarding login credentials and for all activity under its account. Provider shall promptly notify Platform of any unauthorized access.

3. Fees. Provider authorizes Platform to collect platform fees and facilitate patient payouts as described in separately executed payment terms.

4. Acceptable Use. Provider will use the Services only for lawful clinical purposes, in compliance with all applicable federal and state laws including HIPAA, state telehealth regulations, and controlled-substance rules.

5. Term & Termination. Either party may terminate this Agreement with thirty (30) days' written notice; termination for cause is effective immediately upon notice.

6. Disclaimer. The Services are provided "as is" without warranty of any kind. Platform disclaims all implied warranties to the maximum extent permitted by law.

7. Limitation of Liability. Platform's aggregate liability under this Agreement shall not exceed the fees paid by Provider in the twelve (12) months preceding the claim.

8. Governing Law. This Agreement is governed by the laws of the state of Provider's primary practice.

By checking the agreement box below and entering your legal name as a signature, you acknowledge that you have read, understood, and agree to be bound by this Agreement in its final executed form.`

export const BAA_TEXT = `Business Associate Agreement (Placeholder)

This Business Associate Agreement ("BAA") is a placeholder entered into between Determa ("Business Associate") and the provider or provider's practice entity ("Covered Entity") identified in the onboarding signature block. The final legal text will replace this content prior to production launch.

1. Definitions. Capitalized terms not defined here have the meanings ascribed under HIPAA (45 C.F.R. Parts 160 and 164), including "PHI," "Breach," "Required by Law," and "Unsecured Protected Health Information."

2. Permitted Uses. Business Associate will Use or Disclose PHI only to perform the functions, activities, or services for, or on behalf of, Covered Entity, as specified in the Technology Services Agreement, and as Required by Law.

3. Safeguards. Business Associate shall implement administrative, physical, and technical safeguards that reasonably and appropriately protect the Confidentiality, Integrity, and Availability of Electronic PHI.

4. Breach Notification. Business Associate shall report any Breach of Unsecured PHI to Covered Entity without unreasonable delay, and in no event later than sixty (60) days after discovery.

5. Subcontractors. Business Associate shall ensure that any Subcontractors that create, receive, maintain, or transmit PHI on its behalf agree in writing to the same restrictions and conditions that apply to Business Associate.

6. Access & Amendment. Business Associate shall make PHI available to Covered Entity as necessary to satisfy Covered Entity's obligations under 45 C.F.R. § 164.524 (Access) and § 164.526 (Amendment).

7. Return or Destruction. Upon termination, Business Associate shall return or destroy all PHI received from, or created, maintained, or received on behalf of, Covered Entity, where feasible.

8. Term. This BAA is effective as of the date of execution and shall continue until the underlying Technology Services Agreement terminates and all PHI is returned or destroyed.

By checking the agreement box below and entering your legal name as a signature, you acknowledge that you have read, understood, and agree to be bound by this BAA in its final executed form.`

export interface AttestationItem {
  id:
    | 'attest_malpractice'
    | 'attest_scope'
    | 'attest_hipaa'
    | 'attest_telehealth'
  label: string
  description: string
}

export const ATTESTATION_ITEMS: AttestationItem[] = [
  {
    id: 'attest_malpractice',
    label: 'Malpractice insurance',
    description:
      'I carry, and will maintain, professional liability (malpractice) insurance appropriate to my scope of practice.',
  },
  {
    id: 'attest_scope',
    label: 'Scope of practice',
    description:
      'I will practice only within the scope of my license and training and will refer patients outside my scope to an appropriate provider.',
  },
  {
    id: 'attest_hipaa',
    label: 'HIPAA compliance',
    description:
      'I understand my obligations under HIPAA and will use the platform in a manner consistent with protecting patient privacy.',
  },
  {
    id: 'attest_telehealth',
    label: 'Telehealth requirements',
    description:
      'I will comply with all state-specific telehealth requirements applicable to each patient encounter, including licensure and standard-of-care rules.',
  },
]
